import { gql } from "@apollo/client";

export const UPDATE_ESTADO_SUGERENCIA = gql`
    mutation actualizarEstadoProfesionalMonitoreoSugerencia($idsProfesionalMonitoreoSugerencia: [Int!]!, $idEstado: Int! ) {
      actualizarEstadoProfesionalMonitoreoSugerencia(
        idsProfesionalMonitoreoSugerencia: $idsProfesionalMonitoreoSugerencia,
        idEstado: $idEstado
      ) 
  }
`;